import styled from 'styled-components'
import { NavLink } from 'react-router-dom'
import {FiSearch, FiUser} from 'react-icons/fi'


export const NavText = styled(NavLink)`
    color: white;
    display: flex;
    text-decoration: none;
    transition: color 0.20s;
    outline: none;
    &:hover{
    color: rgba(255,255,255,0.4);
    }
`

export const ScaleUser = styled(FiUser)`
   transition: transform 0.2s ease;
   &:hover{
     transform: scale(1.2);
   }
`
export const ScaleSearch = styled(FiSearch)`
  transition: transform 0.2s ease;
   &:hover{
     transform: scale(1.2);
   }
`